export default class TaskQueryDto {
    /**
     * @type {number}
     */
    queryId;

    /**
     * @type {string}
     */
    queryName;

    /**
     * @type {string}
     */
    taskQueryDescription;

    /**
     * @type {Array<TaskQueryField>}
     */
    possibleQueryFields;

    /**
     * @type {Array<TaskQueryField>}
     */
    selectedQueryFields;

    /**
     * @type {Array<TaskQueryField>}
     */
    taskWhere;
}
